import { render, staticRenderFns } from "./AS.vue?vue&type=template&id=6538191a&"
import script from "./AS.vue?vue&type=script&lang=js&"
export * from "./AS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports